import React, { useState } from "react";
import _ from "lodash";
import { setLevel, getLevel, getRegisteredLoggers }  from "@mm/log";

import makeStyles from '@mui/styles/makeStyles';

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Popover from "@mui/material/Popover";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const useStyles = makeStyles({
    select: {
        width: 120
    }
});

export default function LogOptions() {
    const classes = useStyles();

    const [ selected, setSelected ] = useState();
    const [ anchor, setAnchor] = useState();

    const handleClose = () => {
        setSelected(null);
        setAnchor(null);
    };

    const loggers = _.sortBy(getRegisteredLoggers());
    if (_.isEmpty(loggers)) {
        return <p>Aktuell sind keine Logging-Quellen registriert</p>;
    } else {
        return (
            <>
                <Popover
                    open={selected != null}
                    anchorEl={anchor}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left"
                    }}
                >
                    <FormControl className={classes.select}>
                        <InputLabel id="logsettings-level-label">
                            Wählen Sie das Log-Level:
                        </InputLabel>
                        <Select
                            labelId="logsettings-level-label"
                            id="logsettings-level"
                            value={ getLevel(selected) }
                            onChange={ (ev) => {
                                setLevel(ev.target.value, selected);
                                handleClose();
                            }}
                        >
                            <MenuItem value="ERROR">ERROR</MenuItem>
                            <MenuItem value="WARN">WARN</MenuItem>
                            <MenuItem value="INFO">INFO</MenuItem>
                            <MenuItem value="DEBUG">DEBUG</MenuItem>
                            <MenuItem value="TRACE">TRACE</MenuItem>
                        </Select>
                    </FormControl>
                </Popover>
                <List>
                    { loggers.map((l) => (
                        <ListItem 
                            key={l} 
                            button 
                            onClick={ (ev) => {
                                setSelected(l);
                                setAnchor(ev.currentTarget);
                            }}
                        >
                            <ListItemText primary={ l } secondary={ getLevel(l) }/>
                        </ListItem>
                    )) }
                </List>
            </>
        );
    }
}

